import React, { Component } from "react";
import { Radio, Space, message, Spin } from "antd";
import Bridge from "../../utils/Bridge";

export default class PhysicalCharachteristics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dominant_hand: "",
      height_in_feet: "",
      height_in_inches: "",
      weight: "",
      dominant_hand_other_specification: "",
      loading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "What is your dominant hand?") {
                this.setState({ dominant_hand: item.value });
              }
              if (item.field == "Specification") {
                this.setState({
                  dominant_hand_other_specification: item.value,
                });
              }
              if (item.field == "Height In Feet") {
                this.setState({ height_in_feet: item.value });
              }
              if (item.field == "Height In Inches") {
                this.setState({ height_in_inches: item.value });
              }
              if (item.field == "Weight") {
                this.setState({ weight: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  onChangeDominantHand = (event) => {
    this.setState({
      dominant_hand: event.target.value,
      dominant_hand_other_specification: "",
    });
  };
  save = () => {
    if (!this.state.dominant_hand) {
      message.warning("Please select your Dominant hand");
      return;
    }
    if (
      this.state.dominant_hand == "Other" &&
      !this.state.dominant_hand_other_specification
    ) {
      message.warning("Please enter specification of Dominant hand");
      return;
    }
    if (!this.state.height_in_feet) {
      message.warning("Please enter your Height In Feets");
      return;
    }
    if (
      this.state.height_in_feet <= 3 ||
      this.state.height_in_feet >= 9 ||
      this.state.height_in_feet == 0
    ) {
      message.warning("Please enter valid value of Height (In Feet)");
      return;
    }
    if (!this.state.height_in_inches) {
      message.warning("Please enter your Height In Inches");
      return;
    }
    if (this.state.height_in_inches >= 13) {
      message.warning("Please enter valid value of Height (In Inch)");
      return;
    }
    if (!this.state.weight) {
      message.warning("Please enter your Weight In lbs");
      return;
    }
    if (this.state.weight <= 88 || this.state.weight >= 500) {
      message.warning("Please enter valid Weight (In Lbs)");
      return;
    }
    let questions = [
      {
        parent_field: "What is your dominant hand?",
        field: "What is your dominant hand?",
        value: this.state.dominant_hand,
      },
      {
        parent_field: "Specification",
        field: "Specification",
        value: this.state.dominant_hand_other_specification,
      },
      {
        parent_field: "Height In Inches",
        field: "Height In Inches",
        value: this.state.height_in_inches,
      },
      {
        parent_field: "Height In Feet",
        field: "Height In Feet",
        value: this.state.height_in_feet,
      },
      {
        parent_field: "Weight",
        field: "Weight",
        value: this.state.weight,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "4",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(5);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>PHYSICAL CHARACTERISTICS</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                What is your dominant hand?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeDominantHand}
                value={this.state.dominant_hand}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Right"}>Right</Radio>
                  <Radio value={"Left"}>Left</Radio>
                  <Radio value={"Ambidextrous"}>Ambidextrous</Radio>
                </Space>
              </Radio.Group>
            </div>
            {this.state.dominant_hand == "Other" && (
              <div className="form-group">
                <label className="input-heading">
                  Specification <span className="text-danger">*</span>{" "}
                </label>
                <br />
                <textarea
                  name="race_other_specification"
                  value={this.state.dominant_hand_other_specification}
                  onChange={(e) => {
                    this.setState({
                      dominant_hand_other_specification: e.target.value,
                    });
                  }}
                  rows="4"
                  cols="50"
                  maxlength="200"
                ></textarea>
              </div>
            )}
            <div className="form-group">
              <label className="mb-2">
                Height <span className="text-danger">*</span>
              </label>
              <br />
              <div className="row">
                <div className="col-lg-6">
                  <input
                    type="number"
                    placeholder="Feet"
                    name="height_in_feet"
                    value={this.state.height_in_feet}
                    onChange={(e) =>
                      this.setState({ height_in_feet: e.target.value })
                    }
                    min={4}
                  />
                </div>
                <div className="col-lg-6">
                  <input
                    type="number"
                    name="height_in_inches"
                    placeholder="Inches"
                    value={this.state.height_in_inches}
                    onChange={(e) =>
                      this.setState({ height_in_inches: e.target.value })
                    }
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2">
                Weight <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="number"
                name="weight"
                placeholder="Weight (lbs)"
                value={this.state.weight}
                onChange={(e) => this.setState({ weight: e.target.value })}
                max={500}
              />
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  onClick={() => this.props.set_active_step(3)}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
